module.exports = __webpack_public_path__ + "img/relaxed.ba477554.png";